import { IconButton, makeStyles } from '@material-ui/core'
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import {
  ICON_NAMES
} from '../../../../../constants'
import { useContextContainer } from '../../../../../abundanceEngine/components/ContextContainer'
import { CLIENT_VIEW_CONTEXT } from '../..'
import Icon from '../../../../atoms/Icon'

const useStyles = makeStyles((theme) => ({
  iconButton: {
    position: 'inherit',
    padding: '0.75rem',
    backgroundColor: 'var(--theme-color-surface-d0)',
    '&:hover': {
      backgroundColor: 'var(--color-surface-200)'
    }
  }
}))

const WealthBoxButton = ({ clientId, disabled }) => {
  const classes = useStyles()
  const [, setClientViewContext] = useContextContainer(CLIENT_VIEW_CONTEXT)

  const onOpenDrawer = useCallback(() => {
    setClientViewContext((prevState) => ({ ...prevState, drawerOpen: true }))
  }, [setClientViewContext])

  const onClick = useCallback(() => {
    onOpenDrawer()
    setClientViewContext((prevState) => ({
      ...prevState,
      integrationsInfo: { clientId }
    }))
  }, [clientId, onOpenDrawer, setClientViewContext])

  return (
    <IconButton
      size='small'
      className={classes.iconButton}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon
        name={ICON_NAMES.wealthboxSmall}
        customSize='1.125rem'
        padding='1rem'
      />
    </IconButton>
  )
}

WealthBoxButton.propTypes = {
  disabled: PropTypes.bool,
  clientId: PropTypes.number
}

export default WealthBoxButton
